import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { SLIDES } from "../data/data";
import logoImage from "../assets/images/MM-Final-Logo.webp";
import leftArrow from "../assets/images/left-arrow.svg";
import rightArrow from "../assets/images/right-arrow.svg";

export default function HeroSlider() {
  const [cur, setCur] = useState(0);
  const timerRef = useRef(null);
  const navigate = useNavigate(); // ✅ NEW

  const go = (i) => setCur((i + SLIDES.length) % SLIDES.length);

  const reset = (i) => {
    clearInterval(timerRef.current);
    go(i);
    timerRef.current = setInterval(() => setCur(c => (c + 1) % SLIDES.length), 5000);
  };

  useEffect(() => {
    timerRef.current = setInterval(() => setCur(c => (c + 1) % SLIDES.length), 5000);
    return () => clearInterval(timerRef.current);
  }, []);

  return (
    <section className="hero">
      <div className="hero-slides">
        {SLIDES.map((s, i) => (
         <div className={`hero-slide${i === cur ? " active" : ""}`}>
  <img
    src={s.img}
    alt="Healthy millet momos banner"
    className="hero-bg"
    loading={i === 0 ? "eager" : "lazy"}
    fetchpriority={i === 0 ? "high" : "auto"}
    width="1200"
    height="600"
  />
</div>
        ))}
      </div>

      <div className="hero-inner">
        <div className="hero-content">
          <div className="tagline">Guilt Kam Swad Full</div>
          <h1>Healthy Millet Momos for the Modern India</h1>
          <p>
          “Delicious. Nutritious. No Maida. Made with Millets.”
          </p>

          <div className="hero-btns">
            {/* ✅ FIXED */}
            <button
              className="btn-primary"
              onClick={() => navigate("/menu")}
            >
              View Menu
            </button>

            <button
              className="btn-secondary"
              onClick={() => navigate("/about")}
            >
              Learn More
            </button>
          </div>
        </div>

        <div>
                  <img
                      src={logoImage}
                      alt="Millet Momos Healthy Food Logo"
                      className="hero-logo"
                      loading="eager"
                      fetchpriority="high"
                      width="200"
                      height="200"
                  />
        </div>
      </div>

      <button className="slider-arrow prev" onClick={() => reset(cur - 1)}><img src={leftArrow} className="arrowicons" alt="Previous"  loading="lazy" /></button>
      <button className="slider-arrow next" onClick={() => reset(cur + 1)}><img src={rightArrow} className="arrowicons" alt="Next"  loading="lazy" /></button>

      <div className="slider-dots">
        {SLIDES.map((_, i) => (
          <div
            key={i}
            className={`dot${i === cur ? " active" : ""}`}
            onClick={() => reset(i)}
          />
        ))}
      </div>
    </section>
  );
}